import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Helpers from "../Config/Helpers";
import { Link, useNavigate } from "react-router-dom";
import DataTable from "../Components/Datatable";
import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";

function TodayReceipts() {
  const [search, setSearch] = useState("");
  const [receipts, setTodayReceipts] = useState([]);

  let navigate = useNavigate();
  const getTodayReceipts = useCallback(() => {
    axios
      .get(`${Helpers.baseUrl}/receipts/today/${Helpers.authParentId}`, Helpers.headers)
      .then((response) => {
        setTodayReceipts(response.data.reverse());
      })
      .catch((error) => {
        Helpers.unauthenticated(error, navigate);
      });
  }, [navigate]);

  const handleDelete = (receiptId) => {
    iziToast.warning({
      timeout: 20000,
      close: false,
      overlay: true,
      displayMode: "once",
      zindex: 9999,
      title: "",
      message: "Are you sure to delete this receipt",
      position: "center",
      buttons: [
        [
          "<button><b>YES</b></button>",
          function (instance, toast) {
            axios
              .get(
                `${Helpers.baseUrl}/receipts/delete/${receiptId}`,
                Helpers.headers
              )
              .then((response) => {
                getTodayReceipts();
                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                Helpers.toast("success", "Receipt deleted successfully");
              })
              .catch((error) => {
                Helpers.unauthenticated(error, navigate);
                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
              });
          },
          true,
        ],
        [
          "<button>NO</button>",
          function (instance, toast) {
            instance.hide({ transitionOut: "fadeOut" }, toast, "button");
          },
        ],
      ],
    });
  };

  useEffect(() => {
    getTodayReceipts();
  }, [getTodayReceipts]);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0">Today Receipts</h4>
              <Link className="btn btn-success m-1" to="/user/receipts"><i className="fa fa-list"></i> All Receipts</Link>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body border-bottom">
                <div
                  className="row"
                  style={{ justifyContent: "center", alignItems: "center" }}
                >
                  <div className="col-9">
                    <h3>
                    <img src={require('../images/icons/receipt.png')} alt="home" style={{height:40, marginRight:10}} />Today Receipts
                    </h3>
                  </div>
                  <div className="col-3">
                    <label>Search</label>
                    <input
                      className="form-control"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                </div>
                <DataTable
                  columns={[
                    "Sr. #",
                    "Customer",
                    "Vehicle",
                    "Total Price",
                    "Amount Paid",
                    "Amount Remaining",
                    "Payment Status",
                    "Actions",
                  ]}
                >
                  {receipts.map((receipt, index) => {
                    return (
                      <tr key={receipt._id}>
                        <td>{index + 1}</td>
                        <td>{receipt.customer ? receipt.customer.name : ''}</td>
                        <td>{receipt.vehicle ? receipt.vehicle.make+' '+receipt.vehicle.model : ''}</td>
                        <td>$ {receipt.totalPrice}</td>
                        <td>$ {receipt.paid}</td>
                        <td>$ {receipt.remaining}</td>
                        <td>{receipt.status}</td>
                        <td>
                        {
                            receipt.status !== 'Paid' ?
                            <Link className="btn btn-warning btn-sm m-1" to={`/user/unpaid-receipt/make-payment/${receipt._id}`}>
                            Make Payment
                          </Link>:''
                          }
                          
                          <Link
                            to={`/user/receipts/receipt-details/${receipt._id}`}
                            className="btn btn-success btn-sm"
                          >
                            <ion-icon name="eye-outline"></ion-icon>
                          </Link>{" "}
                          <button
                            onClick={() => handleDelete(receipt._id)}
                            type="button"
                            className="btn btn-danger btn-sm"
                          >
                            <ion-icon name="trash-outline"></ion-icon>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </DataTable>
                {receipts.length === 0 ?<div className="text-center">
                  No data available to display
                </div> : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TodayReceipts;
